import { apiOrigin } from "./artemulkContent";

/**
 * Varsayılan şube görselleri (admin fotoğraf yüklemediyse).
 */
export const branchImageUrls = {
  istanbul: "/artemulk/img/branches/istanbul.jpg",
  izmir: "/artemulk/img/branches/izmir.jpg",
  balikesir: "/artemulk/img/branches/balikesir.jpg",
  bandirma: "/artemulk/img/branches/bandirma.jpg",
  bodrum: "/artemulk/img/branches/bodrum.jpg",
};

/** API / admin panelden gelen görseli çöz */
export const getBranchImage = (branchId, apiImage) => {
  const fallback = branchImageUrls[branchId] || branchImageUrls.istanbul;

  if (!apiImage || typeof apiImage !== "string") {
    return fallback;
  }

  const trimmed = apiImage.trim();

  // Admin panelden yüklenen fotoğraf
  if (trimmed.includes("/upload/point/")) {
    if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
      return trimmed;
    }
    return `${apiOrigin}${trimmed.startsWith("/") ? "" : "/"}${trimmed}`;
  }

  // Tam URL (harici veya backend)
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    if (trimmed.includes("unsplash.com") || trimmed.includes("localhost/artemulk")) {
      return fallback;
    }
    return trimmed;
  }

  // Göreli yol (/artemulk/...)
  if (trimmed.startsWith("/")) {
    return trimmed;
  }

  return fallback;
};
